import { render, staticRenderFns } from "./RoomInformationIos.vue?vue&type=template&id=0cd718de&scoped=true&"
import script from "./RoomInformationIos.vue?vue&type=script&lang=ts&"
export * from "./RoomInformationIos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd718de",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd718de')) {
      api.createRecord('0cd718de', component.options)
    } else {
      api.reload('0cd718de', component.options)
    }
    module.hot.accept("./RoomInformationIos.vue?vue&type=template&id=0cd718de&scoped=true&", function () {
      api.rerender('0cd718de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/rooms/RoomInformationIos.vue"
export default component.exports